import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5788c1f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-painel-cliente-page" }
const _hoisted_2 = { class: "ui-forca-vendas-cliente" }
const _hoisted_3 = { class: "ui-mobile-toolbar" }
const _hoisted_4 = { class: "ui-toolbar-title" }
const _hoisted_5 = { class: "ui-toolbar-actions" }
const _hoisted_6 = {
  key: 0,
  class: "ui-mobile-content"
}
const _hoisted_7 = { class: "ui-painel-dados" }
const _hoisted_8 = { class: "ui-campo-bloco" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-campo-label" }, "Nome do Cliente / Razão Social", -1))
const _hoisted_10 = { class: "ui-campo-valor ui-destaque ui-ellipsis" }
const _hoisted_11 = { class: "ui-campo-bloco" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-campo-label" }, "Nome Fantasia", -1))
const _hoisted_13 = { class: "ui-campo-valor ui-destaque" }
const _hoisted_14 = { class: "ui-grid-duas-colunas" }
const _hoisted_15 = { class: "ui-campo-bloco" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-campo-label" }, "Código", -1))
const _hoisted_17 = { class: "ui-campo-valor" }
const _hoisted_18 = { class: "ui-campo-bloco" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-campo-label" }, "CPF / CNPJ", -1))
const _hoisted_20 = { class: "ui-campo-valor" }
const _hoisted_21 = {
  style: {"display":"none"},
  class: "ui-grid-duas-colunas"
}
const _hoisted_22 = { class: "ui-campo-bloco" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-campo-label" }, "Segmento / Canal Distribuição", -1))
const _hoisted_24 = { class: "ui-campo-valor ui-destaque" }
const _hoisted_25 = { class: "ui-campo-bloco" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-campo-label" }, "Trade Marketing", -1))
const _hoisted_27 = { class: "ui-campo-valor" }
const _hoisted_28 = { class: "ui-campo-bloco" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-campo-label" }, "Status Cliente", -1))
const _hoisted_30 = { class: "ui-campo-valor" }
const _hoisted_31 = { class: "ui-painel-botoes" }
const _hoisted_32 = {
  key: 1,
  class: "ui-mobile-content ui-informacoes-content"
}
const _hoisted_33 = { class: "ui-info-cabecalho ui-ellipsis" }
const _hoisted_34 = { class: "ui-info-linha" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fantasia:", -1))
const _hoisted_36 = {
  style: {"display":"none"},
  class: "ui-info-linha-dupla"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Canal:", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Código:", -1))
const _hoisted_39 = { class: "" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "CPF/CNPJ:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-divisor" }, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-secao-titulo" }, "Contatos:", -1))
const _hoisted_43 = { class: "ui-contato-linha" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-contato-icone" }, "☎", -1))
const _hoisted_45 = { class: "ui-contato-linha" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-contato-icone" }, "✉", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-divisor" }, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"display":"none"},
  class: "ui-secao-titulo"
}, "Resumo de Crédito", -1))
const _hoisted_49 = {
  style: {"display":"none"},
  class: "ui-credito-box"
}
const _hoisted_50 = { class: "ui-credito-linha" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Limite de Crédito:", -1))
const _hoisted_52 = { class: "ui-credito-linha" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Limite Utilizado:", -1))
const _hoisted_54 = { class: "ui-credito-linha" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Crédito Disponível:", -1))
const _hoisted_56 = { class: "ui-credito-linha" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Título em Atraso:", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-credito-linha ui-plano" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Plano Recebimento:"),
  /*#__PURE__*/_createElementVNode("strong", null, "-")
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-divisor" }, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-secao-titulo" }, "Endereço", -1))
const _hoisted_61 = { class: "ui-endereco-box" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = {
  key: 2,
  class: "ui-mobile-content ui-ultimas-vendas-content"
}
const _hoisted_64 = { class: "ui-cliente-resumo-vendas" }
const _hoisted_65 = { class: "ui-ellipsis ui-cliente-venda-nome" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fantasia:", -1))
const _hoisted_67 = { class: "ui-info-linha-dupla ui-vendas-docs" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "CPF/CNPJ:", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Código:", -1))
const _hoisted_70 = { class: "ui-abas-vendas" }
const _hoisted_71 = {
  key: 0,
  class: "ui-lista-vendas"
}
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { class: "ui-venda-dados" }
const _hoisted_74 = { class: "ui-venda-grid" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "No. PEDIDO:", -1))
const _hoisted_76 = { class: "ui-pedido-numero" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Emissão:", -1))
const _hoisted_78 = { class: "ui-venda-grid" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Pedido ERP:", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Status:", -1))
const _hoisted_81 = { class: "ui-venda-grid" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Qtde Itens:", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Valor:", -1))
const _hoisted_84 = { class: "ui-forma-pagamento" }
const _hoisted_85 = {
  key: 1,
  class: "ui-itens-venda"
}
const _hoisted_86 = {
  key: 1,
  class: "ui-tabela-itens-wrapper"
}
const _hoisted_87 = { class: "ui-tabela-itens" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Código"),
    /*#__PURE__*/_createElementVNode("th", null, "Produto"),
    /*#__PURE__*/_createElementVNode("th", null, "Quant"),
    /*#__PURE__*/_createElementVNode("th", { style: {"display":"none"} }, "Vlr Tabela"),
    /*#__PURE__*/_createElementVNode("th", { style: {"display":"none"} }, "% Desc"),
    /*#__PURE__*/_createElementVNode("th", null, "Vlr Unit"),
    /*#__PURE__*/_createElementVNode("th", { style: {"display":"none"} }, "Vlr IPI"),
    /*#__PURE__*/_createElementVNode("th", null, "Vlr Total")
  ])
], -1))
const _hoisted_89 = { class: "ui-descricao-item" }
const _hoisted_90 = { style: {"display":"none"} }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"display":"none"} }, "0,00", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"display":"none"} }, "0,00", -1))
const _hoisted_93 = { class: "ui-total-venda" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total Venda", -1))
const _hoisted_95 = {
  key: 3,
  class: "ui-mobile-content ui-edicao-content"
}
const _hoisted_96 = { class: "ui-card" }
const _hoisted_97 = { class: "ui-card-body" }
const _hoisted_98 = { class: "ant-row" }
const _hoisted_99 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_100 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-5"
}
const _hoisted_101 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-5"
}
const _hoisted_102 = { class: "ant-col ant-col-xs-24 ant-col-xl-11" }
const _hoisted_103 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_104 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_105 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_106 = { class: "ant-row" }
const _hoisted_107 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_108 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_109 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-4"
}
const _hoisted_110 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-4"
}
const _hoisted_111 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_112 = { class: "ui-acoes-edicao" }
const _hoisted_113 = { class: "ui-card ui-mt-30" }
const _hoisted_114 = { class: "ui-card-header" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
      /*#__PURE__*/_createElementVNode("span", null, "Endereços")
    ])
  ])
], -1))
const _hoisted_116 = { class: "ui-card-body" }
const _hoisted_117 = { class: "ant-row" }
const _hoisted_118 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_119 = ["onUpdate:modelValue"]
const _hoisted_120 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_121 = ["onUpdate:modelValue"]
const _hoisted_122 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_123 = { class: "ant-row" }
const _hoisted_124 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_125 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_126 = ["onUpdate:modelValue"]
const _hoisted_127 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_128 = ["onUpdate:modelValue"]
const _hoisted_129 = { class: "ant-row" }
const _hoisted_130 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_131 = ["onUpdate:modelValue"]
const _hoisted_132 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_133 = ["onUpdate:modelValue"]
const _hoisted_134 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_135 = { class: "ui-acoes-endereco" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_combo_tipo_pessoa = _resolveComponent("combo-tipo-pessoa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_campo_cnpj = _resolveComponent("campo-cnpj")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_combo_genero = _resolveComponent("combo-genero")!
  const _component_combo_finalidade_produtos = _resolveComponent("combo-finalidade-produtos")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_combo_cidade = _resolveComponent("combo-cidade")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "ui-toolbar-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.voltarTela && _ctx.voltarTela(...args)))
        }, " ‹ "),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.tituloTela), 1),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.state.tela === 'painel' || _ctx.state.tela === 'ultimasVendas')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                style: {"display":"none"},
                type: "button",
                class: "ui-toolbar-btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.baixar && _ctx.baixar(...args)))
              }, " ⬇ "))
            : _createCommentVNode("", true),
          (_ctx.state.tela === 'painel' || _ctx.state.tela === 'informacoes')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                style: {"display":"none"},
                type: "button",
                class: "ui-toolbar-btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.abrirEdicao && _ctx.abrirEdicao(...args)))
              }, " ✎ "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_a_skeleton, {
        loading: _ctx.appBase.carregando
      }, {
        default: _withCtx(() => [
          (_ctx.state.tela === 'painel')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.state.cliente.nomeRazaoSocial || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.nomeFantasiaCliente), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.codigoClienteFormatado), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.cpfCnpjFormatado), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.descricaoCanalCliente), 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.state.cliente.identificacao || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.state.cliente.status ? 'ATIVO' : 'INATIVO'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "ui-botao-principal ui-botao-info",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.abrirInformacoesCliente && _ctx.abrirInformacoesCliente(...args)))
                  }, " INFORMAÇÕES DO CLIENTE "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ui-botao-principal ui-botao-vendas",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.abrirUltimasVendas && _ctx.abrirUltimasVendas(...args)))
                  }, " ÚLTIMAS VENDAS "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ui-botao-principal ui-botao-pedido",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.novoPedido && _ctx.novoPedido(...args)))
                  }, " NOVO PEDIDO ")
                ])
              ]))
            : (_ctx.state.tela === 'informacoes')
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.codigoClienteFormatado) + " - " + _toDisplayString(_ctx.state.cliente.nomeRazaoSocial || '-'), 1),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("span", null, _toDisplayString(_ctx.nomeFantasiaCliente), 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", null, [
                      _hoisted_37,
                      _createElementVNode("span", null, _toDisplayString(_ctx.descricaoCanalCliente), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_38,
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.cliente.codigoErp || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", null, [
                      _hoisted_40,
                      _createElementVNode("span", null, _toDisplayString(_ctx.cpfCnpjFormatado), 1)
                    ])
                  ]),
                  _hoisted_41,
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("span", null, _toDisplayString(_ctx.state.cliente.telefone || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("span", null, _toDisplayString(_ctx.state.cliente.email || '-'), 1)
                  ]),
                  _hoisted_47,
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatarMoeda(0)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatarMoeda(0)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatarMoeda(0)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatarMoeda(0)), 1)
                    ]),
                    _hoisted_58
                  ]),
                  _hoisted_59,
                  _hoisted_60,
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.enderecoPrincipal.endereco || '-') + " " + _toDisplayString(_ctx.enderecoPrincipal.numero || ''), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.enderecoPrincipal.complemento || ''), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.enderecoPrincipal.bairro || ''), 1),
                    _createElementVNode("div", null, [
                      (_ctx.enderecoPrincipal.cep)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_62, " - CEP: " + _toDisplayString(_ctx.formatarCep(_ctx.enderecoPrincipal.cep)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : (_ctx.state.tela === 'ultimasVendas')
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.state.cliente.nomeRazaoSocial || '-'), 1),
                      _createElementVNode("div", null, [
                        _hoisted_66,
                        _createTextVNode(" " + _toDisplayString(_ctx.nomeFantasiaCliente), 1)
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", null, [
                          _hoisted_68,
                          _createTextVNode(" " + _toDisplayString(_ctx.cpfCnpjFormatado), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_69,
                          _createTextVNode(" " + _toDisplayString(_ctx.state.cliente.codigoErp || '-'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass({ 'ui-ativo': _ctx.state.abaUltimasVendas === 'vendas' }),
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.abaUltimasVendas = 'vendas'))
                      }, " PEDIDOS ", 2),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass({ 'ui-ativo': _ctx.state.abaUltimasVendas === 'itens' }),
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.abaUltimasVendas = 'itens'))
                      }, " ITENS ", 2)
                    ]),
                    (_ctx.state.abaUltimasVendas === 'vendas')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                          (!_ctx.UtilitarioGeral.validaLista(_ctx.state.pedidos))
                            ? (_openBlock(), _createBlock(_component_a_empty, {
                                key: 0,
                                description: "Nenhuma venda encontrada"
                              }))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.pedidos, (pedido, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: pedido.codigo,
                              class: "ui-venda-card",
                              onClick: ($event: any) => (_ctx.selecionarPedido(index))
                            }, [
                              _createElementVNode("div", {
                                class: "ui-status-barra",
                                style: _normalizeStyle('background-color:' + _ctx.servicoPedido.obterCorStatus(pedido.status) + ';')
                              }, [
                                _createElementVNode("span", null, _toDisplayString(index + 1), 1)
                              ], 4),
                              _createElementVNode("div", _hoisted_73, [
                                _createElementVNode("div", _hoisted_74, [
                                  _createElementVNode("div", null, [
                                    _hoisted_75,
                                    _createElementVNode("span", _hoisted_76, _toDisplayString(pedido.numeroIdentificacao), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _hoisted_77,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.formatarData(pedido.data)), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_78, [
                                  _createElementVNode("div", null, [
                                    _hoisted_79,
                                    _createElementVNode("span", null, _toDisplayString(pedido.numeroErp || '-'), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _hoisted_80,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.servicoPedido.obterDescricaoStatus(pedido.status)), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_81, [
                                  _createElementVNode("div", null, [
                                    _hoisted_82,
                                    _createElementVNode("span", null, _toDisplayString(pedido.itens.length), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _hoisted_83,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.formatarMoeda(pedido.valorTotal)), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_84, _toDisplayString(pedido.detalhesFormaPagamento || 'DINHEIRO'), 1)
                              ])
                            ], 8, _hoisted_72))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_85, [
                          (!_ctx.UtilitarioGeral.validaLista(_ctx.itensUltimasVendas))
                            ? (_openBlock(), _createBlock(_component_a_empty, {
                                key: 0,
                                description: "Nenhum item encontrado"
                              }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                _createElementVNode("table", _hoisted_87, [
                                  _hoisted_88,
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itensUltimasVendas, (item) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: item.chave
                                      }, [
                                        _createElementVNode("td", null, _toDisplayString(item.sku || item.codigoProduto), 1),
                                        _createElementVNode("td", _hoisted_89, _toDisplayString(item.produto), 1),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatarQuantidade(item.quantidade)), 1),
                                        _createElementVNode("td", _hoisted_90, _toDisplayString(_ctx.formatarMoedaCompacta(item.precoUnitario)), 1),
                                        _hoisted_91,
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatarMoedaCompacta(item.precoUnitario)), 1),
                                        _hoisted_92,
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatarMoedaCompacta(item.valorTotal)), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_93, [
                                  _hoisted_94,
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatarMoeda(_ctx.totalItensUltimasVendas)), 1)
                                ])
                              ]))
                        ]))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_95, [
                    _createVNode(_component_a_form, { layout: "vertical" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("div", _hoisted_97, [
                            _createElementVNode("div", _hoisted_98, [
                              _createElementVNode("div", _hoisted_99, [
                                _createVNode(_component_a_form_item, { label: "Tipo Pessoa" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_combo_tipo_pessoa, {
                                      valor: _ctx.state.cliente.tipoPessoa,
                                      "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.cliente.tipoPessoa) = $event))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              (_ctx.state.cliente.tipoPessoa === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                    _createVNode(_component_a_form_item, { label: "CPF" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_campo_cpf, {
                                          valor: _ctx.state.cliente.cpfCnpj,
                                          "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.cliente.cpfCnpj) = $event))
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.state.cliente.tipoPessoa === 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                    _createVNode(_component_a_form_item, { label: "CNPJ" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_campo_cnpj, {
                                          valor: _ctx.state.cliente.cpfCnpj,
                                          "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.cliente.cpfCnpj) = $event)),
                                          onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.consultaCnpj()))
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_102, [
                                _createVNode(_component_a_form_item, {
                                  label: _ctx.state.cliente.tipoPessoa === 1 ? 'Nome' : 'Razão Social'
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.cliente.nomeRazaoSocial) = $event)),
                                      type: "text",
                                      class: "ant-input"
                                    }, null, 512), [
                                      [_vModelText, _ctx.state.cliente.nomeRazaoSocial]
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _createElementVNode("div", _hoisted_103, [
                                _createVNode(_component_a_form_item, { label: "Status" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio_group, {
                                      value: _ctx.state.cliente.status,
                                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.cliente.status) = $event)),
                                      "button-style": "solid"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_radio_button, { value: false }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Inativo")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_radio_button, { value: true }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Ativo")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            (_ctx.state.cliente.tipoPessoa === 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                  _createElementVNode("div", _hoisted_105, [
                                    _createVNode(_component_a_form_item, { label: "Nome Fantasia" }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("input", {
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.cliente.nomeFantasia) = $event)),
                                          type: "text",
                                          class: "ant-input"
                                        }, null, 512), [
                                          [_vModelText, _ctx.state.cliente.nomeFantasia]
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_106, [
                              _createElementVNode("div", _hoisted_107, [
                                _createVNode(_component_a_form_item, { label: "Telefone" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_telefone, {
                                      valor: _ctx.state.cliente.telefone,
                                      "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.cliente.telefone) = $event))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_108, [
                                _createVNode(_component_a_form_item, {
                                  label: _ctx.state.cliente.tipoPessoa === 1 ? 'Data de Nascimento' : 'Data de Abertura'
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_data, {
                                      dataSelecionada: _ctx.state.cliente.dataNascimentoAbertura,
                                      "onUpdate:dataSelecionada": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.cliente.dataNascimentoAbertura) = $event))
                                    }, null, 8, ["dataSelecionada"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              (_ctx.state.cliente.tipoPessoa === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                    _createVNode(_component_a_form_item, { label: "Gênero" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_combo_genero, {
                                          valor: _ctx.state.cliente.genero,
                                          "onUpdate:valor": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.cliente.genero) = $event))
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (_ctx.state.cliente.tipoPessoa === 2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                      _createVNode(_component_a_form_item, { label: "Finalidade dos Produtos" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_combo_finalidade_produtos, {
                                            valor: _ctx.state.cliente.finalidadeProdutos,
                                            "onUpdate:valor": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.cliente.finalidadeProdutos) = $event))
                                          }, null, 8, ["valor"])
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_111, [
                                _createVNode(_component_a_form_item, { label: "Código ERP" }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.cliente.codigoErp) = $event)),
                                      type: "text",
                                      class: "ant-input"
                                    }, null, 512), [
                                      [_vModelText, _ctx.state.cliente.codigoErp]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_112, [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                onClick: _ctx.salvar
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Salvar ")
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_a_button, {
                                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.state.tela = 'painel'))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Voltar ")
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_113, [
                          _createElementVNode("div", _hoisted_114, [
                            _hoisted_115,
                            _createVNode(_component_a_button, {
                              type: "primary",
                              size: "small",
                              onClick: _ctx.adicionarEndereco
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Adicionar ")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _createElementVNode("div", _hoisted_116, [
                            _createVNode(_component_a_collapse, {
                              activeKey: _ctx.state.chaveEndereco,
                              "onUpdate:activeKey": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.chaveEndereco) = $event)),
                              accordion: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.cliente.enderecos, (endereco, index) => {
                                  return (_openBlock(), _createBlock(_component_a_collapse_panel, {
                                    key: index,
                                    header: _ctx.UtilitarioGeral.valorValido(endereco.identificacao) ? endereco.identificacao : (index + 1) + 'º Endereço'
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_117, [
                                        _createElementVNode("div", _hoisted_118, [
                                          _createVNode(_component_a_form_item, { label: "Identificação" }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((endereco.identificacao) = $event),
                                                type: "text",
                                                placeholder: "Descreva como você deseja identificar este endereço",
                                                class: "ant-input"
                                              }, null, 8, _hoisted_119), [
                                                [_vModelText, endereco.identificacao]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _createElementVNode("div", _hoisted_120, [
                                          _createVNode(_component_a_form_item, { label: "Destinatário" }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((endereco.destinatario) = $event),
                                                type: "text",
                                                placeholder: "Pessoa ou responsável que vai receber os produtos",
                                                class: "ant-input"
                                              }, null, 8, _hoisted_121), [
                                                [_vModelText, endereco.destinatario]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _createElementVNode("div", _hoisted_122, [
                                          _createVNode(_component_a_form_item, { label: "Endereço Principal?" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_radio_group, {
                                                value: endereco.principal,
                                                "onUpdate:value": ($event: any) => ((endereco.principal) = $event),
                                                "button-style": "solid"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_radio_button, { value: false }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Não")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_a_radio_button, { value: true }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Sim")
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 2
                                              }, 1032, ["value", "onUpdate:value"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_123, [
                                        _createElementVNode("div", _hoisted_124, [
                                          _createVNode(_component_a_form_item, { label: "CEP" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_campo_cep, {
                                                valor: endereco.cep,
                                                "onUpdate:valor": ($event: any) => ((endereco.cep) = $event),
                                                onBlur: ($event: any) => (_ctx.consultaCep(index))
                                              }, null, 8, ["valor", "onUpdate:valor", "onBlur"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _createElementVNode("div", _hoisted_125, [
                                          _createVNode(_component_a_form_item, { label: "Endereço/Logradouro" }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((endereco.endereco) = $event),
                                                type: "text",
                                                class: "ant-input"
                                              }, null, 8, _hoisted_126), [
                                                [_vModelText, endereco.endereco]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _createElementVNode("div", _hoisted_127, [
                                          _createVNode(_component_a_form_item, { label: "Número" }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((endereco.numero) = $event),
                                                type: "text",
                                                class: "ant-input"
                                              }, null, 8, _hoisted_128), [
                                                [_vModelText, endereco.numero]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_129, [
                                        _createElementVNode("div", _hoisted_130, [
                                          _createVNode(_component_a_form_item, { label: "Complemento" }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((endereco.complemento) = $event),
                                                type: "text",
                                                class: "ant-input"
                                              }, null, 8, _hoisted_131), [
                                                [_vModelText, endereco.complemento]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _createElementVNode("div", _hoisted_132, [
                                          _createVNode(_component_a_form_item, { label: "Bairro" }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((endereco.bairro) = $event),
                                                type: "text",
                                                class: "ant-input"
                                              }, null, 8, _hoisted_133), [
                                                [_vModelText, endereco.bairro]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _createElementVNode("div", _hoisted_134, [
                                          _createVNode(_component_a_form_item, { label: "Cidade/UF" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_combo_cidade, {
                                                codigo: endereco.codigoCidade,
                                                "onUpdate:codigo": ($event: any) => ((endereco.codigoCidade) = $event)
                                              }, null, 8, ["codigo", "onUpdate:codigo"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_135, [
                                        (_ctx.state.cliente.enderecos.length > 1)
                                          ? (_openBlock(), _createBlock(_component_a_button, {
                                              key: 0,
                                              danger: "",
                                              size: "small",
                                              onClick: ($event: any) => (_ctx.removerEndereco(index))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Remover ")
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["header"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["activeKey"])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]))
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}